<template>
<div class="viewmarket" :class="{'active':mmFollowRecordListSubmit.length > 0 || mmFollowPlanList.length>0}">
  <div class="viewmarket--header">
    <div class="viewmarket--header--title">
      <div class="title--left iconfont" @click="handleToMarketCancelBtn">&#xe600;</div>
      <div class="title--text" v-if="$route.params.routeTag === 'public'">公海客户</div> <!--公海-->
      <div class="title--text" v-else-if="$route.params.routeTag === 'hismarket'">历史客户</div>
      <div class="title--text" v-else>客户/渠道</div>
      <div class="title--tel iconfont" @click="vanMarketDetailShow=true">
        &#xe7b5;
      </div>
    </div>
    <div class="viewmarket--header--info">
      <div class="info--company">
        <div class="company--text">{{marketDetailData.cusName}}</div>
        <div class="company--edit" @click="handleToEditorMarket($route.params.routeTag)" v-if="matterPhase === '1' && couldEdit === true">编辑</div>
        <div class="company--edit" @click="handleToEditorMarket($route.params.routeTag)" v-else>查看</div>
      </div>
      <div class="info--item" v-if="false">
        <div class="item--status">当前阶段:  {{marketDetailData.matterPhaseName}}</div>
      </div>
      <div class="info--item" v-if="false">
        <div class="item--time">更新时间:  {{marketDetailData.updateDate}}</div>
      </div>
      <div class="info--item">
        <div class="item--time">项目组成员:  {{marketDetailData.actornames}}</div>
      </div>
      <div class="info--item" v-if="false">
        <div class="item--status">客户地址:  {{marketDetailData.address}}</div>
      </div>
      <div class="info--item" v-if="false">
        <div class="item--status">所属产业:  {{viewMarketIndustryText}}</div>
      </div>
      <div class="info--item">
        <div class="item--status">创建时间:  {{marketDetailData.inputDate}}</div>
      </div>
    </div>
    <div class="viewmarket--header--item">
      <div
        class="item--left"
        :class="{'active':marketDetailHeaderFlag === 'record'}"
        @click="handleToChange('record')"
      >
        营销日志<span>{{marketDetailData.mmFollowRecordsForMatter?marketDetailData.mmFollowRecordsForMatter:'0'}}</span>
      </div>
      <div
        class="item--center"
        :class="{'active':marketDetailHeaderFlag === 'plan'}"
        @click="handleToChange('plan')"
      >
        跟进计划<span>{{marketDetailData.mmFollowPlansForMatter?marketDetailData.mmFollowPlansForMatter:'0'}}</span>
      </div>
      <div
        class="item--other"
        :class="{'active':marketDetailHeaderFlag === 'other'}"
        @click="handleToChange('other')"
      >
        其他记录<span>{{marketDetailData.mmFollowRecordsForCus?marketDetailData.mmFollowRecordsForCus:'0'}}</span>
      </div>
    </div>
    <div class="viewmarket--header--desc" v-if="mmFollowRecordList.length>0 && marketDetailHeaderFlag !== 'plan' && false">
      <van-swipe class="my-swipe" indicator-color="#7186d3">
        <van-swipe-item
          v-for="item in mmFollowRecordList"
          :key="item.id"
        >
          <div
            class="header--desc--card"
            @click="handleToModifyFollowRecord(item)">
            <div class="desc--text">
              <div class="desc--address">{{item.visitDate}} {{item.address}}</div>
              <div class="desc--status">已保存为草稿，请完善后提交。</div>
            </div>
            <div class="desc--icon iconfont">&#xe62c;</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
  <div class="viewmarket--line" :class="{active: true || mmFollowRecordList.length===0 }"></div>
  <div class="viewmarket--info" v-if="mmFollowRecordListSubmit.length >0">
    <div
      class="viewmarket--info--item"
      v-for="Submititem in mmFollowRecordListSubmit"
      :key="Submititem.id"
      @click="handleToModifyFollowRecord(Submititem)"
    >
      <div class="item--title">
        <div class="title--desc">{{Submititem.cusName}}</div>
        <div class="title--status" v-if="Submititem.followType">{{Submititem.followType | getFollowTypeText(FollowTypeText)}}</div>
      </div>
      <div class="item--addr">
          <div class="title--time">{{Submititem.visitDate | getMonDay}}</div>
          <div class="title--addr" v-if="Submititem.followType === '1'">{{Submititem.address?Submititem.address:'未定位'}}</div>
      </div>
      <div class="item--desc">{{Submititem.remark}}</div>
      <div
        class="item--swiper"
        v-if="Submititem.docEReceiveList.length > 0"
      >
        <swiper
          class="echw-fb-swiper"
          :options="swiperOption"
        >
          <swiper-slide
            class="echw-fb-swiper-slide"
            v-for="(imgItem,imgIndex) in Submititem.docEReceiveList"
            :key="imgItem.pk"
          >
            <img @click.stop="handleToMarketDetailImg(Submititem.docEReceiveList,imgIndex)" class="swiper--img" :src="imgItem.downloadUrl" alt="">
          </swiper-slide>
          <div v-if="false" class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
      <div class="item--follow">
        <div class="item--follow--person">参与人:{{Submititem.actornames}}</div>
      </div>
    </div>
  </div>
  <div class="viewmarket--info" v-else-if="mmFollowPlanList.length > 0">
    <div
      class="plain--info--item"
      v-for="item in mmFollowPlanList"
      :key="item.id"
    >
      <div class="item--title">{{item.cusName}}</div>
      <div class="item--content">
        <div class="item--content--info">
          <div class="info--time">计划日期:<span>{{item.planTime}}</span></div>
          <div class="info--person">提醒人:<span>{{item.actornames}}</span></div>
        </div>
        <div class="item--content--icon iconfont" v-if="false">&#xe7b5;</div>
      </div>
      <div class="item--text">{{item.remark}}</div>
      <div class="item--func">
        <div class="func--cancle" @click="handleToMarketDelPlan(item)">删除</div>
        <div class="func--modify" @click="handleToMarketModifyPlan(item)">修改</div>
        <div class="func--record" @click="handleToMarketAddRecord(item)">填写营销日志</div>
      </div>
    </div>
  </div>
  <div class="viewmarket--info" v-else>
    <van-empty description="暂无数据" />
  </div>
  <div class="viewmarket--footer" v-if="matterPhase === '1' && couldEdit === true">
    <div class="viewmarket--footer--item  iconfont" @click="handleToAddFollowRecord('addfollowup')">
      营销日志 <span>&#xe602;</span>
    </div>
    <div class="viewmarket--footer--item iconfont" @click="handleToAddFollowRecord('addplain')">
      跟进计划 <span>&#xe602;</span>
    </div>
  </div>
  <van-popup
    v-model="vanMarketDetailShow"
    closeable
    position="bottom"
    :style="{ height: '30%' }"
  >
    <div
      class="market--tel"
      v-for="contractItem in marketDetailmmContactsList"
      :key="contractItem.id"
      @click="handleToMarketDetailCallTel(contractItem.contactPhone)"
    >
      <div class="market--tel--name">{{contractItem.contactName}}</div>
      <div class="market--tel--num">{{contractItem.contactPhone}}</div>
    </div>
  </van-popup>
  <div class="viewmarket--big--img">
    <div class="md-example-child md-example-child-image-reader">
      <md-image-viewer
        v-model="imgShow"
        :list="imgurlList"
        :has-dots="true"
        :initial-index="imgIndex">
      </md-image-viewer>
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { get, post } from '../api/api'
import { ImageViewer } from 'mand-mobile'
import { getIndustryDict, getFollowupType } from '../tools/common'
import recordPageTime from '../mixin/minin'
export default {
  name: 'viewMarket',
  components: {
    [ImageViewer.name]: ImageViewer
  },
  data () {
    return {
      swiperOption: {
        centeredSlides: false, // 当前slide居中显示
        slidesPerView: 3, // 1是显示1个banner, 'auto'自适应
        spaceBetween: 12, // slide间隔（px）
        loop: false,
        autoplay: false,
        delay: 5000, // 自动轮播， 默认 3000 ms
        simulateTouch: true, // 鼠标拖拽
        allowTouchMove: true, // 触摸滑动
        lazyLoading: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      },
      pageNum: 1, // 获取跟进记录列表从那一条开始
      pageSize: 10, // 获取跟进记录列表一共多少条
      vanMarketDetailShow: false, // 控制电话显示
      marketDetailHeaderFlag: 'record', // 控制header 底部三块显色
      marketDetailData: '', // 营销事项详细信息数据
      marketDetailmmContactsList: [], // 联系人信息
      mmFollowRecordList: [], // 跟进记录处于保存的列表
      mmFollowRecordListSubmit: [], // 跟进记录处于提交的列表
      viewMarketIndustryText: '', // 所属产业文本(显示使用)
      VMRecordTotal: '', // 营销事项对应的跟进记录总数
      certCode: '', // 获取其他跟进记录使用
      matterPhase: '1', // 控制该营销事项是否可编辑
      mmFollowPlanList: [], // 跟进计划列表
      scrollNum: 50, // 滑动到底部提前控制触发的数值
      scrollVMarketFlag: true, // 控制滑动pageNum在没有返回值的时候不能加1
      FollowTypeText: [],
      imgurlList: [], // 控制图片全屏显示
      imgShow: false, // 控制图片全屏显示
      imgIndex: 0, // 控制图片全屏显示
      couldEdit: true // 控制不是改事项创建人、参与人是否可见、可编辑、可添加
    }
  },
  beforeMount () {
    this.getMarketDetail()
  },
  mounted () {
    const viewmarketContentElement = document.body
    viewmarketContentElement.addEventListener('scroll', this.handleToVMRecordScroll, true)
  },
  destroyed () {
    const viewmarketContentElement = document.body
    viewmarketContentElement.removeEventListener('scroll', this.handleToVMRecordScroll, true)
  },
  methods: {
    // 获取客户营销事项详细信息
    async getMarketDetail () {
      if (!this.$route.params.id) {
        this.$router.push('/market')
        return false
      }
      this.FollowTypeText = await getFollowupType()
      const result = await get('/api/CBMS-APP/mmMarketMatter/info', {
        id: this.$route.params.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        this.scrollVMarketFlag = true
        this.marketDetailData = result.data
        this.certCode = result.data.certCode
        this.couldEdit = result.data.couldEdit
        this.matterPhase = result.data.matterPhase
        this.marketDetailmmContactsList = result.data.mmContactsList
        this.mmFollowRecordList = result.data.mmFollowRecordList.filter(item => item.couldEdit === true)
        this.mmFollowRecordListSubmit = this.mmFollowRecordListSubmit.concat(result.data.mmFollowRecordPageSubmit.records)
        this.VMRecordTotal = result.data.mmFollowRecordPageSubmit.total
        this.viewMarketIndustryText = this.viewMarketIndustryText ? this.viewMarketIndustryText : await getIndustryDict(result.data.cusIndustry)
      } else {
        this.$toast.success('获取数据出错')
      }
    },
    // 打电话
    handleToMarketDetailCallTel (contactPhone) {
      window.location.href = `tel://${contactPhone}`
    },
    // 修改已经添加的营销事项
    handleToEditorMarket (routeTag) {
      if (this.marketDetailData.matterType === '0') {
        this.$router.push({
          name: 'AddMarket',
          params: {
            oldMarketData: this.marketDetailData,
            id: this.$route.params.id,
            routerName: 'ViewMarket',
            routeTag
          }
        })
      } else {
        this.$router.push({
          name: 'addchannel',
          params: {
            oldMarketData: this.marketDetailData,
            id: this.$route.params.id,
            routerName: 'ViewMarket',
            routeTag
          }
        })
      }
    },
    // 修改已经保存的营销事项
    handleToModifyFollowRecord (item) {
      this.$router.push({
        name: 'addfollowup',
        params: {
          item,
          modifyTag: true,
          routerName: 'ViewMarket',
          id: this.marketDetailData.id,
          routeTag: this.$route.params.routeTag
        }
      })
    },
    // 从营销事项里添加跟进|计划记录（把cusName、certcode、营销id带过去）
    handleToAddFollowRecord (forwardName) {
      this.$router.push({ name: forwardName, params: { id: this.marketDetailData.id, certCode: this.marketDetailData.certCode, cusName: this.marketDetailData.cusName, modifyTag: false, routerName: 'ViewMarket' } })
    },
    // 滑动到底部触发，获取更多跟进记录
    handleToVMRecordScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        this.pageNum = this.pageNum + 1
        if (this.mmFollowRecordListSubmit.length < this.VMRecordTotal && this.marketDetailHeaderFlag === 'record' && this.scrollVMarketFlag) {
          this.scrollVMarketFlag = false
          this.getMarketDetail()
        } else if (this.mmFollowRecordListSubmit.length < this.VMRecordTotal && this.marketDetailHeaderFlag === 'other') {
          this.scrollVMarketFlag = false
          this.getOtherRecordList()
        } else if (this.mmFollowPlanList.length < this.VMRecordTotal && this.marketDetailHeaderFlag === 'plan') {
          this.scrollVMarketFlag = false
          this.getPlainList()
        } else if (this.mmFollowPlanList.length === this.VMRecordTotal || this.mmFollowRecordListSubmit.length === this.VMRecordTotal) {
          this.scrollNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    },
    // 切换跟进记录、跟进计划、其他记录
    async handleToChange (val) {
      this.marketDetailHeaderFlag = val
      this.pageNum = 1
      this.mmFollowRecordListSubmit = []
      this.mmFollowPlanList = []
      this.VMRecordTotal = ''
      if (val === 'record') {
        this.getMarketDetail()
      } else if (val === 'other') {
        this.getOtherRecordList()
      } else if (val === 'plan') {
        this.getPlainList()
      }
    },
    // 获取其他跟进记录列表
    async getOtherRecordList () {
      const result = await get('/api/CBMS-APP/mmFollowRecord/listforcus', {
        relMatterId: this.$route.params.id,
        certCode: this.certCode,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        this.scrollVMarketFlag = true
        this.mmFollowRecordListSubmit = this.mmFollowRecordListSubmit.concat(result.data.mmFollowRecordIPage.records)
        this.VMRecordTotal = result.data.mmFollowRecordIPage.total
      }
    },
    // 获取跟进计划列表
    async getPlainList () {
      const result = await get('/api/CBMS-APP/mmFollowPlan/listforcus', {
        relMatterId: this.$route.params.id,
        certCode: this.certCode,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        this.scrollVMarketFlag = true
        this.mmFollowPlanList = this.mmFollowPlanList.concat(result.data.mmFollowPlanIPage.records)
        this.VMRecordTotal = result.data.mmFollowPlanIPage.total
      }
    },
    // 删除跟进计划
    handleToMarketDelPlan (itemobj) {
      if (!itemobj.couldEdit) {
        this.$toast.success('无权限删除')
        return false
      }
      this.$dialog.confirm({
        title: itemobj.cusName,
        message: '确认删除跟进计划'
      })
        .then(async () => {
          const result = await post('/api/CBMS-APP/mmFollowPlan/remove', { id: itemobj.id })
          if (result.success) {
            this.$toast.success({
              message: '已删除',
              onClose: () => {
                this.mmFollowPlanList = this.mmFollowPlanList.filter(item => item.id !== itemobj.id)
              }
            })
          }
        })
        .catch(() => {
          this.$toast.success('已取消')
        })
    },
    // 修改跟进计划
    handleToMarketModifyPlan (itemobj) {
      this.$router.push({ name: 'addplain', params: { id: this.marketDetailData.id, item: itemobj, modifyTag: true, routerName: 'ViewMarket' } })
    },
    // 添加跟进记录
    handleToMarketAddRecord (itemobj) {
      this.$router.push({ name: 'addfollowup', params: { id: itemobj.relMatterId, certCode: itemobj.certCode, cusName: itemobj.cusName, modifyTag: false, routerName: 'ViewMarket' } })
    },
    // 返回按钮
    handleToMarketCancelBtn () {
      if (this.$route.params.routerName) {
        this.$router.push({ name: this.$route.params.routerName })
      } else if (this.$route.params.routeTag) {
        this.$router.push({ name: this.$route.params.routeTag })
      } else {
        this.$router.push('/')
      }
    },
    // 轮播点击图片触发函数
    handleToMarketDetailImg (imgList, imgIndex) {
      // this.imgurlList = []
      // this.imgIndex = 0
      imgList.forEach(item => {
        this.imgurlList.push(item.downloadUrl)
      })
      this.imgIndex = imgIndex
      this.imgShow = true
    }
  },
  watch: {
    imgShow (newVal, oldVal) {
      if (!newVal) {
        this.imgurlList = []
        this.imgIndex = 0
      }
    }
  },
  filters: {
    getFollowTypeText (val, list) {
      const data = list.filter(item => item.enname === val)[0]
      return data.cnname
    },
    getMonDay (time) {
      return time.split(' ')[0].split('-').slice(1).join('-')
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.viewmarket
  position : relative
  width : 100vw
  height : 100vh
  background-color : #ffffff
  overflow-x : hidden
  overflow-y : scroll
  &.active
    padding-bottom : 116px
  &>>>.van-overlay
    z-index : 100
  .viewmarket--img
    display: flex
    align-items: center
    justify-content: center
    height: 100%
    .viewmarket--img-item
      width : 100%
      height : 400px
      background-color : #ffffff
      img
        width : 100%
        height : 100%
  .viewmarket--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .viewmarket--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      padding : 0 16px
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--left
        font-size : 48px
        width : 80px
        text-align : left
        color : #ffffff
      .title--tel
        font-size : 48px
        width : 80px
        text-align : center
        a
          color : #ffffff
      .title--text
        flex : 1
        text-align : center
    .viewmarket--header--info
      background-color : #7186d3
      padding: 16px
      .info--company
        display : flex
        font-family: MyriadPro-Regular
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
        .company--text
          flex : 1
          margin-top : 16px
          padding : 8px 0
        .company--edit
          width : 80px
          margin-top : 16px
          padding : 8px 16px
          text-align : center
          border : 1px solid #f7f7f7
          border-radius : 12px
          font-size: 32px
      .info--item
        display : flex
        margin : 0 32px
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
        .item--status
          flex : 1
          padding : 8px 0
        .item--time
          flex : 1
          padding : 8px 0
    .viewmarket--header--item
      display : flex
      background-color : #f7f7f7
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      color: #333333
      border-bottom : 1px solid #b6b5b5
      .item--left
        flex : 1
        text-align : center
        padding : 16px 0
        border-right : .5px solid #b6b5b5
        &.active
          border-bottom : 5px solid #7186d3
        span
          padding : 4px 16px
          margin-left : 8px
          background-color : #7186d3
          color: #ffffff
          border-radius : 12px
      .item--center
        flex : 1
        text-align : center
        padding : 16px 0
        border-left : .5px solid #b6b5b5
        border-right : .5px solid #b6b5b5
        &.active
          border-bottom : 5px solid #7186d3
        span
          padding : 4px 16px
          margin-left : 8px
          background-color : #7186d3
          color: #ffffff
          border-radius : 12px
      .item--other
        flex : 1
        text-align : center
        padding : 16px 0
        border-left : .5px solid #b6b5b5
        &.active
          border-bottom : 5px solid #7186d3
        span
          padding : 4px 16px
          margin-left : 8px
          background-color : #7186d3
          color: #ffffff
          border-radius : 12px
    .viewmarket--header--empty
      padding : 36px 16px
      box-sizing : border-box
      border-bottom : 1px solid #b6b5b5
      background-color : #ffffff
      text-align : center
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      color: #b6b5b5
    .viewmarket--header--desc
      padding : 16px
      box-sizing : border-box
      border-bottom : 1px solid #b6b5b5
      background-color : #ffffff
      .header--desc--card
        display : flex
        align-items : center
        .desc--text
          flex : 1
          font-family: MyriadPro-Regular
          font-size: 26px
          font-weight: normal
          font-stretch: normal
          color: #333333
          overflow : hidden
          .desc--address
            width : 100%
            color : #ecbd62
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .desc--status
            margin-top : 8px
            font-size : 34px
            color : #ecbd62
        .desc--icon
          width : 80px
          text-align : right
          color : #ecbd62
      &>>>.van-swipe__indicators
        bottom : 0
      &>>>.van-swipe__indicator
        background-color : #a6a1a1
  .viewmarket--line
    width : 100%
    height: 460px
    &.active
      height : 355px
  .viewmarket--info
    .viewmarket--info--item
      margin : 16px 16px 0 16px
      padding : 16px 16px 0 16px
      border-radius : 16px
      background-color : #f7f7f7
      .item--title
        display : flex
        justify-content : center
        align-items : center
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .title--desc
          flex : 1
          color: #7186d3
          text-overflow:ellipsis
          overflow:hidden
          white-space:nowrap
        .title--status
          font-size: 28px
          border : 1px solid #a6a1a1
          padding : 4px 8px
          text-align : center
          width : 140px
          border-radius : 12px
      .item--desc
        padding : 16px 0
        line-height : 38px
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
      .item--swiper
        padding : 16px
        height : 210px
        .echw-fb-swiper
          width : 100%
          height : 210px
          .echw-fb-swiper-slide
            height : 210px
            img
              width : 100%
              height : 100%
      .item--follow
        display : flex
        justify-content : center
        align-items : center
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .item--follow--person
          flex : 1
          font-size: 28px
          padding : 16px 0
          text-align : right
      .item--addr
        display : flex
        padding-bottom : 16px
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
        .title--time
          width : 120px
        .title--addr
          text-overflow:ellipsis
          overflow:hidden
          white-space:nowrap
    .plain--info--item
      margin : 16px 16px 0 16px
      padding : 16px
      background-color : #ffffff
      border-radius : 12px
      border : 1px solid #b6b5b5
      font-size : 28px
      .item--title
        padding : 16px
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
      .item--content
        display : flex
        justify-content : center
        align-items : center
        padding : 16px
        .item--content--icon
          padding: 16px
          font-size : 48px
          font-weight: normal
          font-stretch: normal
          color : #7186d3
        .item--content--info
          flex : 1
          font-size: 28px
          font-weight: normal
          font-stretch: normal
          color: #333333
          .info--time
            padding-bottom : 8px
            span
              padding-left : 16px
          .info--person
            padding-top : 8px
            span
              padding-left : 16px
      .item--text
        padding : 16px
        line-height : 1.5
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
      .item--func
        display : flex
        padding : 16px
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .func--cancle
          flex : 1
          padding : 8px 0
          text-align : center
        .func--modify
          flex : 1
          padding : 8px 0
          text-align : center
          border-right : 1px solid #b6b5b5
          border-left : 1px solid #b6b5b5
        .func--record
          flex : 2
          padding : 8px 0
          text-align : center
  .viewmarket--footer
    display : flex
    position : fixed
    bottom:0
    left:0
    width : 100%
    z-index : 10
    background :#ffffff
    border-top : 2px solid #b6b5b5
    .viewmarket--footer--item
      flex : 1
      padding : 32px 0
      text-align : center
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #7186d3
      &:nth-child(1)
        border-right : .5px solid #b6b5b5
      &:nth-child(2)
        border-left : .5px solid #b6b5b5
      span
        padding-left : 16px
  .market--tel
    display : flex
    margin-top : 32px
    font-family: MyriadPro-Regular
    font-size: 28px
    font-weight: normal
    font-stretch: normal
    color : #4282e1
    &:nth-child(1)
      margin-top : 80px
    .market--tel--name,.market--tel--num
      flex : 1
      padding : 16px 0
      text-align : center
    .market--tel--num
      text-align : left
</style>
